import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// icons
import CustomIcons from 'components/CustomIcons';

function SortButton({
  uniqueKey,
  onSort,
  sortByAsc,
  // default props
  className
}) {
  const childClassNames = classNames('extra-bar-item', 'sort-extra', className);
  
  return (
    <div
      key={`sort-by-list-${uniqueKey}`}
      className={childClassNames}
      onClick={onSort}
    >
      <CustomIcons
        className={`${sortByAsc ? 'ascend' : 'descend'}`}
        type="sort"
      />
    </div>
  );
};

SortButton.defaultProps = {
  sortByAsc: false,
  sortBy: 'descend',
  uniqueKey: 'simple'
};
SortButton.propTypes = {
  sortBy: PropTypes.oneOf(['ascend', 'descend']).isRequired,
  sortByAsc: PropTypes.bool,
  uniqueKey: PropTypes.string,
  onSort: PropTypes.func,
};

export default memo(SortButton);